import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { PerformanceGroupId, } from "../../Types";
import ValidationError from "../../ZodError";
export const DateStringYYYYMMDD = z.custom((val) => (typeof val === "string" ? /^\d{4}-\d{2}-\d{2}$/.test(val) : false)); // YYYY-MM-DD
const DateRange = z.object({
    startDate: DateStringYYYYMMDD,
    endDate: DateStringYYYYMMDD,
});
const DateBalance = z.object({
    date: DateStringYYYYMMDD,
    balance: z.number(),
});
const DateRangePoint = z.object({
    dateRange: DateRange.nullable(),
    beginningMarketValue: z.number(),
    endingMarketValue: z.number(),
    heldEntirePeriod: z.boolean(),
    containsHistory: z.boolean(),
    netGains: z.number().nullable(),
    netAdditions: z.number().nullable(),
    fees: z.number(),
    timeWeightedReturns: z.object({ returns: z.number() }).nullable(),
});
export const AccountGroupPerformance = z.object({
    accountGroupId: PerformanceGroupId,
    dateRangePoints: DateRangePoint.array(),
    balanceSummary: DateBalance.array(),
});
export const singleAccountGroupV4PerformanceEntireKeyMaker = (accountGroupId) => [url(accountGroupId)];
export const getCacheStringFromDateRange = (dateRanges) => {
    if (dateRanges === null) {
        return "null";
    }
    if (dateRanges.length === 0) {
        return "null";
    }
    const dateRangesLength = dateRanges.length;
    const startDate = dateRanges[0]?.startDate ?? "";
    const endDate = dateRanges[dateRangesLength - 1]?.endDate ?? "";
    return `${startDate} -> ${endDate} (${dateRanges.length})`;
};
export const singleAccountGroupV4PerformanceSpecificKeyMaker = (accountGroupId, requestBody) => {
    const dr = getCacheStringFromDateRange(requestBody.dateRanges);
    return [
        ...singleAccountGroupV4PerformanceEntireKeyMaker(accountGroupId),
        requestBody.feeMethod,
        requestBody.returnMethod,
        dr,
    ];
};
export const url = (accountGroupId) => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/account-groups/v4/account-groups/${accountGroupId}/performance`
        : `https://middleware.uat.farther.com/account-groups/v4/account-groups/${accountGroupId}/performance`;
};
export default async function getSingleAccountGroupPerformanceV4(accountGroupId, body, config) {
    const { data } = await axios.post(url(accountGroupId), body, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ...("clientId" in config && { Client: config.clientId }),
        },
    });
    const decoded = AccountGroupPerformance.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "getSingleAccountGroupPerformanceV4 returned unexpected data.";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getSingleAccountGroupPerformanceV4.js.map